
import Barcode from 'react-barcode';
import Custombarcode from './components/barcode';
import { templateMock } from './constant';

const PdfTemplate9 = ({ data, userInfo }: any) => {
  const renderData = data || templateMock;

  return (
    <>
      {renderData &&
        renderData.map((item: any) => (
          <div className="templates  [&>div]:text-[7pt]  flex flex-col   w-[6cm]  " style={{ pageBreakInside: 'avoid' }}>
            <div className="flex flex-col items-center  rounded-lg ">
                 <p>باکسیت</p>
         
                {!!data ? (
                  <Barcode width={1.5} height={40} fontSize={10} value={item.cprNumber} displayValue={true} />
                ) : (
                  <Custombarcode />
                )}
          
            </div>
          </div>
        ))}

      <style>{`
            @media print {
              @page {
                size: 6cm 2.5cm;
                     
              }   
            }
            `}</style>
    </>
  );
};

export default PdfTemplate9;
